import { styled } from '@mui/material';

import { Icons, mergeSx, SxProps } from '@cast/design-system';

type StyledIconProps = { isReadOnly: boolean };

const styledOptions = {
  shouldForwardProp: (prop: keyof StyledIconProps) => prop !== 'isReadOnly',
};

// recommended === requested
const CheckIcon = styled(
  Icons.CheckCircle,
  styledOptions
)<StyledIconProps>(({ theme, isReadOnly }) => ({
  color: isReadOnly ? theme.palette.green[100] : theme.palette.green[500],
}));

// recommended < requested
const DownscalingIcon = styled(
  Icons.CaretDown,
  styledOptions
)<StyledIconProps>(({ theme, isReadOnly }) => ({
  color: isReadOnly ? theme.palette.green[100] : theme.palette.green[500],
}));

// recommended > requested
const UpscalingIcon = styled(
  Icons.CaretUp,
  styledOptions
)<StyledIconProps>(({ theme, isReadOnly }) => ({
  color: isReadOnly ? theme.palette.red[100] : theme.palette.red[300],
}));

type Props = {
  diff?: number;
  sx?: SxProps;
  testId?: string;
  isReadOnly?: boolean;
} & Icons.IconProps;

export const DiffIcon = ({
  diff,
  sx,
  testId = 'diff-icon',
  isReadOnly = false,
  ...rest
}: Props) => {
  const size = rest.fontSize || rest.size;

  const isDownscaling = (diff || 0) < 0;
  let type = isDownscaling ? 'downscaling' : 'upscaling';
  let Icon = isDownscaling ? DownscalingIcon : UpscalingIcon;
  if (!diff) {
    type = 'optimal';
    Icon = CheckIcon;
  }

  return (
    <Icon
      data-testid={testId}
      data-type={type}
      data-diff={diff}
      weight="fill"
      sx={mergeSx(
        {
          minWidth: size,
          fontSize: size,
          visibility: diff === undefined ? 'hidden' : undefined,
        },
        sx
      )}
      isReadOnly={isReadOnly}
      {...rest}
    />
  );
};
